import { render } from "./AdminAddonProducts.vue?vue&type=template&id=2ecfbe31&scoped=true"
import script from "./AdminAddonProducts.vue?vue&type=script&lang=js"
export * from "./AdminAddonProducts.vue?vue&type=script&lang=js"

import "./AdminAddonProducts.vue?vue&type=style&index=0&id=2ecfbe31&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ecfbe31"]])

export default __exports__